import { render, staticRenderFns } from "./QLArticolo.vue?vue&type=template&id=237d2eb2&scoped=true&"
import script from "./QLArticolo.vue?vue&type=script&lang=js&"
export * from "./QLArticolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d2eb2",
  null
  
)

export default component.exports